/* eslint-disable no-prototype-builtins */
import { produce } from 'immer';

import { REMOVE, RESET, RESET_REDUX, SET, UPDATE } from './constants';
import initialState from './initialState';

const getActionKeys = (key: string) => {
  return key.split('.');
};

const hasSubKeyInAction = (key: string) => {
  return key.includes('.');
};

const handleSetAction = (action: any, draft: any) => {
  if (action?.data?.data) {
    if (hasSubKeyInAction(action.key)) {
      const [key, subkey] = getActionKeys(action.key);
      draft[key][subkey] = action.data?.data;
      if (action.data?.pagination) {
        draft[key].pagination.totalData = action.data?.pagination?.totalData;
        draft[key].pagination.totalPages = action.data?.pagination?.totalPages;

        draft[key].pagination.totalVisibleData = action?.data?.data?.length;
      }
    } else {
      draft[action.key] = action.data?.data;
      if (action.data?.pagination) {
        draft.pagination = {
          ...action.data?.pagination,
          totalVisibleData: action?.data?.data?.length,
        };
      }
    }
  } else {
    if (hasSubKeyInAction(action.key)) {
      const [key, subkey] = getActionKeys(action.key);
      draft[key][subkey] = action.data;
    } else {
      draft[action.key] = action.data;
    }
  }
};

const handleUpdateAction = (action: any, draft: any) => {
  if (hasSubKeyInAction(action.key)) {
    const [key, subkey] = getActionKeys(action.key);
    if (draft[key].hasOwnProperty([subkey])) {
      if (Array.isArray(draft[key][subkey])) {
        if (action?.data?.data) {
          const newData = action.data.data;
          let updatedDate = [];
          if (action?.data?.position && action?.data?.position === 'front') {
            updatedDate = [...newData, ...draft[key][subkey]];
          } else {
            updatedDate = [...draft[key][subkey], ...newData];
          }
          draft[key][subkey] = updatedDate;
          if (action.data?.pagination) {
            draft[key].pagination.totalData =
              action.data?.pagination?.totalData;
            draft[key].pagination.totalPages =
              action.data?.pagination?.totalPages;

            draft[key].pagination.totalVisibleData =
              action.data?.pagination?.totalVisibleData + 1;
          }
        } else {
          draft[key][subkey] = [...draft[key][subkey], ...action.data];
        }
      } else if (
        initialState[key] &&
        initialState[key][subkey] &&
        typeof initialState[key][subkey] === 'object'
      ) {
        draft[key][subkey] = { ...draft[key][subkey], ...action.data };
      } else {
        draft[key][subkey] = action.data;
      }
    }
  } else {
    if (draft.hasOwnProperty([action.key])) {
      if (Array.isArray(draft[action.key])) {
        if (action?.data?.data) {
          const newData = action.data.data;

          draft[action.key] = [...draft[action.key], ...newData];
          if (action.data?.pagination) {
            draft.pagination = action.data?.pagination;
          }
        } else {
          draft[action.key] = [...draft[action.key], ...action.data];
        }
      } else if (typeof initialState === 'object') {
        draft[action.key] = { ...draft[action.key], ...action.data };
      } else {
        draft[action.key] = action.data;
      }
    }
  }
};

const handleResetAction = (action: any, draft: any) => {
  if (hasSubKeyInAction(action.key)) {
    const [key, subkey] = getActionKeys(action.key);
    draft[key][subkey] = initialState[key][subkey];
  } else {
    draft[action.key] = initialState[action.key];
  }
};

const handleRemoveAction = (action: any, draft: any) => {
  const prevData = draft[action.key];
  if (prevData?.data && prevData?.pagination) {
    const filterData = prevData?.data?.filter(
      (item: any) => item?._id !== action.id
    );
    const updateData = {
      data: filterData,
      pagination: {
        ...prevData?.pagination,
        count: prevData?.pagination?.count - 1,
        totalVisibleData: filterData?.length,
      },
    };
    draft[action.key] = updateData;
  }
};

const appReducer = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state = initialState,
  action: {
    key?: keyof typeof initialState;
    data?: any;
    type: string;
  }
) =>
  produce(state, (draft: any) => {
    switch (action.type) {
      case RESET_REDUX:
        return initialState;
      case SET:
        handleSetAction(action, draft);
        break;
      case RESET:
        handleResetAction(action, draft);
        break;
      case REMOVE:
        handleRemoveAction(action, draft);
        break;

      case UPDATE: {
        handleUpdateAction(action, draft);
        break;
      }
    }
  });

export default appReducer;
